import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import type { Functions } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBmxtKtL4LtBxbdKGHUjT8ErJVFYtIAhvk",
  authDomain: "atrium-crastu.firebaseapp.com",
  projectId: "atrium-crastu",
  storageBucket: "atrium-crastu-uploads",
  messagingSenderId: "1016958509308",
  appId: "1:1016958509308:web:092aebe5034b4e0fa2f779",
};

console.log("FIREBASE_INIT", {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
});

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");

// E2E-only: connect to local emulators instead of production Firebase.
// Never enabled by default — production/dev behavior is unchanged unless
// VITE_USE_FIREBASE_EMULATORS is explicitly set (see e2e/README + playwright
// config, which sets it for the E2E dev server only).
if (import.meta.env.VITE_USE_FIREBASE_EMULATORS === "true") {
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  // eslint-disable-next-line no-console
  console.log("FIREBASE_EMULATORS_CONNECTED", { firestore: 8080, functions: 5001, auth: 9099 });
}

console.log("FIREBASE_INSTANCES", {
  appInstance: app.name,
  authSame: auth.app.name === app.name,
  functionsSame: functions.app.name === app.name,
});
